import { Component, effect, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { User } from '../../../model/user.model';
import { LocationAdminStore } from '../location.admin.store.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { HighlightStatusDirective } from '../../../directives/highlight-status.directive';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'user-management',
  templateUrl: './user-management.component.html',
  imports: [
    MatButton,
    MatDivider,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIcon,
    MatTooltip,
    HighlightStatusDirective,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    TitleCasePipe
  ]
})
export class UserManagementComponent {
  @Input() repairSiteStatus: string;
  @Input() currentUser: User;
  @Output() addEditUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() enableDisableUser: EventEmitter<{ user: User; disable: boolean }> = new EventEmitter<any>();
  @Output() confirmDeleteInvitedUser: EventEmitter<string> = new EventEmitter<any>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  usersDataSource: MatTableDataSource<User>;
  usersColumnHeaders = ['permission', 'username', 'firstName', 'lastName', 'phone', 'email', 'isActivated', 'kebab'];
  activeColumn = 'permission';

  locationAdminStore = inject(LocationAdminStore);

  constructor() {
    effect(() => {
      if (this.locationAdminStore.usersOfRepairerSite().length) {
        this.usersDataSource = new MatTableDataSource(this.locationAdminStore.usersOfRepairerSite());
        this.usersDataSource.sortingDataAccessor = this.sortingDataAccessor;
        this.usersDataSource.sort = this.sort;
      }
    });
  }
  sortingDataAccessor(item, property) {
    if (property === 'permission') {
      return item.privileges.length > 0 ? 'Administrator' : 'Repairer';
    } else if (property === 'isActivated') {
      return item.isActivated ? (item.status === 'ENABLED' ? 'Active' : item.status) : 'Invited';
    }
    return item[property];
  }

  onSortEvent(event) {
    this.activeColumn = event.active;
  }
}
